import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import qs from 'qs';

import IconInsuranceCheck from 'components/icons/IconInsuranceCheck';
import IconBilling from 'components/icons/IconBilling';
import IconDownloadCloud from 'components/icons/IconDownloadCloud';
import IconDocuments from 'components/icons/IconDocuments';
import IconOrdersAdd from 'components/icons/IconOrdersAdd';
import IconSpeaker from 'components/icons/IconSpeaker';
import PatientsDialog from 'components/patient/PatientsDialog';
import ShareDialog from 'components/common/ShareDialog';
import DocumentsSignDialog from 'components/common/DocumentsSignDialog';
import QuickNavigationItem from './QuickNavigationItem';

const styles = () => ({
  root: {
    marginBottom: 12,
  },
  iconInsuranceCheck: {
    width: 30,
    height: 60,
    marginLeft: 8,
    verticalAlign: 'bottom',
    // margin: '0 0 -21px -15px',
    // transform: 'scale(0.5)',
  },
  iconBilling: {
    width: 42,
    height: 50,
    verticalAlign: 'bottom',
    margin: '0 0 -6px -4px',
    // margin: '0 0 -27px -27px',
    // transform: 'scale(0.5)',
  },
  iconDownloadCloud: {
    width: 38,
    height: 50,
    verticalAlign: 'bottom',
    margin: '0 0 4px 4px',
    // margin: '0 0 -10px -12px',
    // transform: 'scale(0.6)',
  },
  iconDocuments: {
    width: 28,
    height: 46,
    verticalAlign: 'bottom',
    margin: '0 0 4px 8px',
    // margin: '0 0 -24px -17px',
    // transform: 'scale(0.43)',
  },
  iconOrdersAdd: {
    width: 26,
    height: 46,
    verticalAlign: 'bottom',
    margin: '0 0 4px 8px',
    // margin: '0 0 -19px -10px',
    // transform: 'scale(0.5)',
  },
  iconSpeaker: {
    width: 32,
    height: 44,
    verticalAlign: 'bottom',
    margin: '0 0 4px 8px',
    // margin: '0 0 -23px -18px',
    // transform: 'scale(0.48)',
  },
});

const billingParams = qs.stringify({
  Billing: true,
}, {
  encode: false, addQueryPrefix: true,
});

class QuickNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      insurancesDialogOpen: false,
      documentsDialogOpen: false,
      formsDialogOpen: false,
      shareDialogOpen: false,
      selectedPatient: null,
      signDialogOpen: false,
      printFormValues: null,
    };

    this.onPatientClick = this.onPatientClick.bind(this);
    this.onPatientClear = this.onPatientClear.bind(this);
    this.onInsurancesButtonClick = this.onInsurancesButtonClick.bind(this);
    this.onInsurancesDialogClose = this.onInsurancesDialogClose.bind(this);
    this.onDocumentsButtonClick = this.onDocumentsButtonClick.bind(this);
    this.onDocumentsDialogClose = this.onDocumentsDialogClose.bind(this);
    this.onFormsButtonClick = this.onFormsButtonClick.bind(this);
    this.onFormsDialogClose = this.onFormsDialogClose.bind(this);
    this.onShareButtonClick = this.onShareButtonClick.bind(this);
    this.onShareDialogClose = this.onShareDialogClose.bind(this);
    this.onInsuranceCreate = this.onInsuranceCreate.bind(this);
    this.onDocumentCreate = this.onDocumentCreate.bind(this);
    this.onPrintDialogSign = this.onPrintDialogSign.bind(this);
    this.onSignDialogClose = this.onSignDialogClose.bind(this);
  }

  onInsurancesButtonClick() {
    this.setState({
      insurancesDialogOpen: true,
      selectedPatient: null,
    });
  }

  onInsurancesDialogClose() {
    this.setState({ insurancesDialogOpen: false });
  }

  onDocumentsButtonClick() {
    this.setState({
      documentsDialogOpen: true,
      selectedPatient: null,
    });
  }

  onDocumentsDialogClose() {
    this.setState({ documentsDialogOpen: false });
  }

  onFormsButtonClick() {
    this.setState({
      formsDialogOpen: true,
      selectedPatient: null,
    });
  }

  onFormsDialogClose() {
    this.setState({ formsDialogOpen: false });
  }

  onPatientClick(patient) {
    this.setState({ selectedPatient: patient });
  }

  onPatientClear() {
    this.setState({ selectedPatient: null });
  }

  onShareButtonClick() {
    this.setState({ shareDialogOpen: true });
  }

  onShareDialogClose() {
    this.setState({ shareDialogOpen: false });
  }

  onDocumentCreate(document) {
    const { selectedPatient } = this.state;
    this.setState({
      selectedPatient: {
        ...selectedPatient,
        Documents: [
          document,
          ...selectedPatient.Documents,
        ],
      },
    });
  }

  onInsuranceCreate(insurance) {
    const { selectedPatient } = this.state;
    this.setState({
      selectedPatient: {
        ...selectedPatient,
        'Insurance Information': [
          insurance,
          ...selectedPatient['Insurance Information'],
        ],
      },
    });
  }

  onPrintDialogSign(values) {
    this.setState({
      formsDialogOpen: false,
      printFormValues: values,
      signDialogOpen: true,
    });
  }

  onSignDialogClose() {
    this.setState({ signDialogOpen: false });
  }

  render() {
    const { classes } = this.props;
    const {
      insurancesDialogOpen,
      documentsDialogOpen,
      formsDialogOpen,
      shareDialogOpen,
      selectedPatient,
      signDialogOpen,
      printFormValues,
    } = this.state;
    return (
      <Toolbar
        className={classes.root}
        disableGutters
      >
        <Grid
          container
          justify="flex-start"
          spacing={16}
        >
          <Grid
            item
            xs={4}
          >
            <QuickNavigationItem
              title="Insurance Eligibility"
              text="Insurance Eligibility is available for your practice"
              icon={(
                <IconInsuranceCheck className={classes.iconInsuranceCheck} />
              )}
              onClick={this.onInsurancesButtonClick}
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <QuickNavigationItem
              title="Billing"
              text="Create and send superbills from your EHR"
              icon={(
                <IconBilling className={classes.iconBilling} />
              )}
              href={`/workflow${billingParams}`}
              target="_blank"
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <QuickNavigationItem
              title="Download Docs"
              text="Add clinical notes to patient Charts"
              icon={(
                <IconDownloadCloud className={classes.iconDownloadCloud} />
              )}
              onClick={this.onDocumentsButtonClick}
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <QuickNavigationItem
              title="Forms"
              text="Print or Make Forms & Delivery Tickets"
              icon={(
                <IconDocuments className={classes.iconDocuments} />
              )}
              onClick={this.onFormsButtonClick}
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <QuickNavigationItem
              title="Add New Order"
              text="Create a new order as quick as possible"
              icon={(
                <IconOrdersAdd className={classes.iconOrdersAdd} />
              )}
              href="/workflow/order/create/patient-assign"
              target="_blank"
            />
          </Grid>
          <Grid
            item
            xs={4}
          >
            <QuickNavigationItem
              title="Spread the word"
              text="Tell your Coleagues about DME"
              icon={(
                <IconSpeaker className={classes.iconSpeaker} />
              )}
              onClick={this.onShareButtonClick}
            />
          </Grid>
        </Grid>
        <PatientsDialog
          open={insurancesDialogOpen}
          onClose={this.onInsurancesDialogClose}
          onPatientClick={this.onPatientClick}
          onPatientClear={this.onPatientClear}
          selectedPatient={selectedPatient}
          onInsuranceCreate={this.onInsuranceCreate}
          variant="insurances"
        />
        <PatientsDialog
          open={documentsDialogOpen}
          onClose={this.onDocumentsDialogClose}
          onPatientClick={this.onPatientClick}
          onPatientClear={this.onPatientClear}
          selectedPatient={selectedPatient}
          onDocumentCreate={this.onDocumentCreate}
          variant="documents"
        />
        <PatientsDialog
          open={formsDialogOpen}
          onClose={this.onFormsDialogClose}
          onPatientClick={this.onPatientClick}
          onPatientClear={this.onPatientClear}
          selectedPatient={selectedPatient}
          onSign={this.onPrintDialogSign}
          variant="forms"
        />
        <DocumentsSignDialog
          open={signDialogOpen}
          onClose={this.onSignDialogClose}
          printFormValues={printFormValues}
          patient={selectedPatient}
          variant="patient"
        />
        <ShareDialog
          open={shareDialogOpen}
          onClose={this.onShareDialogClose}
        />
      </Toolbar>
    );
  }
}

QuickNavigation.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconInsuranceCheck: PropTypes.string.isRequired,
    iconBilling: PropTypes.string.isRequired,
    iconDownloadCloud: PropTypes.string.isRequired,
    iconDocuments: PropTypes.string.isRequired,
    iconOrdersAdd: PropTypes.string.isRequired,
    iconSpeaker: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(QuickNavigation);



// WEBPACK FOOTER //
// ./src/components/home/QuickNavigation/QuickNavigation.js